/** Integer shares of one complete population. Mirrors Services completionDistribution. */
export const distributionPercentages = (counts: number[]): number[] => {
  const total = counts.reduce((sum, count) => sum + Math.max(0, count), 0);
  if (!total) return counts.map(() => 0);
  const shares = counts.map(count => Math.max(0, count) * 100 / total);
  const result = shares.map(Math.floor);
  let remaining = 100 - result.reduce((sum, value) => sum + value, 0);
  const candidates = shares.map((share, index) => ({ index, remainder: share - result[index] }))
    .filter(({ index }) => counts[index] > 0 && result[index] < 99)
    .sort((a, b) => b.remainder - a.remainder || b.index - a.index);
  for (const { index } of candidates) {
    if (!remaining) break;
    result[index] += 1;
    remaining -= 1;
  }
  return result;
};
